"use strict";
var forEach = require('lodash.foreach');
var debounce = require('lodash.debounce');
var classList = require('classlist');
var matches = require('matches-selector-universal');

module.exports = [
    {
        name: 'click',
        init : function (bindingData, model, view) {
            this.addEventListener('click', function () {
                bindingData.apply(view, arguments);
            });
        }
    }, {
        // binds to object attributes. Attributes should be specified as a map from key (attribute name) to value (attribute value) in the binding expression. Attributes are set using Element.prototype.setAttribute
        name: 'prop',
        update : function () {
            forEach(arguments[0], function (attrValue, attrName) {
                if (!attrValue) {
                    this.removeAttribute(attrName);
                } else {
                    this.setAttribute(attrName, true);
                }
            }.bind(this));
        }
    }, {
        name: 'attr',
        update : function () {
            forEach(arguments[0], function (attrValue, attrName) {
                this.setAttribute(attrName, attrValue);
            }.bind(this));
        }
    }, {
        name: 'style',
        update : function () {
            forEach(arguments[0], function (attrValue, attrName) {
                this.setAttribute(attrName, attrValue);
            }.bind(this));
        }
    }, {
        name: 'css',
        update : function (bindingData) {
            var nodeClassList = classList(this);
            forEach(bindingData, function (v, k) {
                nodeClassList[v ? 'add' : 'remove'].apply(nodeClassList, k.split(' '));
            });
        }
    }, {
        // if the binding expression is false, the element is hidden, otherwise the element is shown.
        name: 'visible',
        update : function (bindingData) {
            if (bindingData) {
                this.style.display = '';
            } else {
                this.style.display = 'none';
            }
        }
    }, {
        name: 'hidden',
        update : function (bindingData) {
            this.style.visibility = bindingData ? 'visible' : 'hidden';
        }
    },
    {
        name: 'textarea',
        init : function (bindingData, model) {
            this.addEventListener('keyup', debounce(function () {
                model.set(bindingData, this.value);
            }.bind(this), 200));
        }
    }, {
        // binds the text of an element (using textContent property of element instance) to the binding expression
        name: 'text',
        update : function (bindingData) {
            this.textContent = bindingData;
        }
    }, {
        // binds the html of an element (using innerHTML property of element instance) to the binding expression
        name: 'html',
        update : function (bindingData) {
            this.innerHTML = bindingData;
        }
    }, {
        // binds the value of an input field to the value of the binding expression
        name: 'val',
        update: function (bindingData) {
            if (this.matches(':radio,:checkbox') && !matches(this, ':checked')) { // TODO: handle this case when the need arises
                console.warn("val binding for checkable elements is not yet supported");
                return;
            }
            this.value = bindingData;
        }
    }, {
        name: 'contenteditable',
        init : function (bindingData, model) {
            var contenteditable = this.getAttribute('contenteditable');
            var property = contenteditable.match(/^plaintext/) ? 'textContent' : 'innerHTML';
            var handler = function () {
                model.set(bindingData, this[property]());
            }.bind(this);
            ['change', 'keyup', 'keydown'].forEach(function (eventName) {
                this.addEventListener(eventName, handler);
            }.bind(this));
        }
    }, {
        name: 'contenteditablePlaintext',
        init : function (bindingData, model) {
            var handler = function () {
                model.set(bindingData, this.textContent);
            }.bind(this);
            ['change', 'keyup', 'keydown'].forEach(function (eventName) {
                this.addEventListener(eventName, handler);
            }.bind(this));
        }
    }, {
        name: 'modelval',
        init : function (bindingData, model) {
            this.addEventListener('change', function () {
                model.set(bindingData, this.value);
            }.bind(this));
        }
    }
];



//////////////////
// WEBPACK FOOTER
// ./~/b3nd/b3ndings/core.js
// module id = 152
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56